export default __webpack_public_path__ + "static/media/goshen85.4fc8b9d9.jpg";